export const HOME = {};

export const NAV = {
  logoLink: "nav-logo-link",
  loginBtn: "nav-login-btn",
  signupBtn: "nav-signup-btn",
  themeToggle: "nav-theme-toggle",
  logoutBtn: "nav-logout-btn",
  dashboardLink: "nav-dashboard-link",
  tutorLink: "nav-tutor-link",
  pathsLink: "nav-paths-link",
  progressLink: "nav-progress-link",
  certificatesLink: "nav-certificates-link",
  coachLink: "nav-coach-link",
  mobileMenuBtn: "nav-mobile-menu-btn",
};

export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  submitBtn: "auth-submit-btn",
  switchLink: "auth-switch-link",
  errorText: "auth-error-text",
};

export const LANDING = {
  heroCta: "landing-hero-cta",
  heroSecondaryCta: "landing-hero-secondary-cta",
  featuresSection: "landing-features-section",
  pricingSection: "landing-pricing-section",
  faqSection: "landing-faq-section",
  enterpriseSection: "landing-enterprise-section",
  ctaSection: "landing-cta-section",
};

export const DASHBOARD = {
  root: "dashboard-root",
  welcome: "dashboard-welcome",
  streakCard: "dashboard-streak-card",
  currentCourses: "dashboard-current-courses",
  recommended: "dashboard-recommended",
  certificatesCount: "dashboard-cert-count",
  sessionsCount: "dashboard-session-count",
  quickAskBtn: "dashboard-quick-ask-btn",
};

export const PATHS = {
  root: "paths-root",
  card: (slug) => `paths-card-${slug}`,
  categoryFilter: (cat) => `paths-cat-${cat}`,
  detailEnrollBtn: "paths-enroll-btn",
  lessonLink: (i) => `paths-lesson-link-${i}`,
};

export const LESSON = {
  root: "lesson-root",
  completeBtn: "lesson-complete-btn",
  quizStartBtn: "lesson-quiz-start-btn",
  quizOption: (qi, oi) => `lesson-quiz-q${qi}-opt${oi}`,
  quizSubmit: "lesson-quiz-submit",
  askTutorBtn: "lesson-ask-tutor-btn",
};

export const TUTOR = {
  root: "tutor-root",
  newSessionBtn: "tutor-new-session-btn",
  sessionItem: (id) => `tutor-session-${id}`,
  input: "tutor-input",
  sendBtn: "tutor-send-btn",
  quickAction: (k) => `tutor-quick-${k}`,
  message: (i) => `tutor-msg-${i}`,
  modelSelect: "tutor-model-select",
};

export const PROGRESS = {
  root: "progress-root",
  pathRow: (slug) => `progress-row-${slug}`,
  generateCertBtn: (slug) => `progress-cert-btn-${slug}`,
};

export const CERTS = {
  root: "certs-root",
  card: (id) => `certs-card-${id}`,
  downloadBtn: (id) => `certs-download-${id}`,
};

export const COACH = {
  root: "coach-root",
  kindSelect: (k) => `coach-kind-${k}`,
  contextInput: "coach-context-input",
  generateBtn: "coach-generate-btn",
  output: "coach-output",
};

export const ONBOARDING = {
  root: "onboarding-root",
  nameInput: "onboarding-name-input",
  personality: (p) => `onboarding-personality-${p}`,
  pace: (p) => `onboarding-pace-${p}`,
  style: (s) => `onboarding-style-${s}`,
  goalsInput: "onboarding-goals-input",
  nextBtn: "onboarding-next-btn",
  backBtn: "onboarding-back-btn",
  submitBtn: "onboarding-submit-btn",
};

export const ASSESSMENT = {
  root: "assessment-root",
  startBtn: "assessment-start-btn",
  answerInput: "assessment-answer-input",
  submitAnswerBtn: "assessment-submit-answer-btn",
  viewRoadmapBtn: "assessment-roadmap-btn",
};

export const ASK = {
  menu: "ask-menu",
  action: (k) => `ask-action-${k}`,
  panel: "ask-panel",
  closeBtn: "ask-close-btn",
};

export const SHARE = {
  linkedin: (id) => `share-linkedin-${id}`,
  twitter: (id) => `share-twitter-${id}`,
  facebook: (id) => `share-facebook-${id}`,
  whatsapp: (id) => `share-whatsapp-${id}`,
  copy: (id) => `share-copy-${id}`,
  embed: (id) => `share-embed-${id}`,
};

export const CODING = {
  root: "coding-root",
  langSelect: (l) => `coding-lang-${l}`,
  editor: "coding-editor",
  reviewBtn: "coding-review-btn",
  runBtn: "coding-run-btn",
  exerciseBtn: "coding-exercise-btn",
  reviewOutput: "coding-review-output",
};

export const PROJECTS = {
  root: "projects-root",
  card: (id) => `projects-card-${id}`,
  generateBtn: (slug) => `projects-generate-${slug}`,
  detailRoot: "project-detail-root",
  stepInput: "project-step-input",
  stepSendBtn: "project-step-send-btn",
  submissionInput: "project-submission-input",
  submitBtn: "project-submit-btn",
};

export const ANALYTICS = {
  root: "analytics-root",
  confidenceCard: "analytics-confidence",
  velocityChart: "analytics-velocity-chart",
  growthChart: "analytics-growth-chart",
  strongList: "analytics-strong-list",
  weakList: "analytics-weak-list",
};

export const PORTFOLIO = {
  root: "portfolio-root",
  goalInput: "portfolio-goal-input",
  goalSaveBtn: "portfolio-goal-save-btn",
  shareBtn: "portfolio-share-btn",
};

export const FEEDBACK = {
  fabBtn: "feedback-fab-btn",
  panel: "feedback-panel",
  kind: (k) => `feedback-kind-${k}`,
  messageInput: "feedback-message-input",
  submitBtn: "feedback-submit-btn",
  ratingStar: (n) => `feedback-star-${n}`,
};

export const ADMIN = {
  root: "admin-root",
  createInvitesBtn: "admin-create-invites-btn",
  feedbackList: "admin-feedback-list",
};
